<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: '',

    metaInfo: { title: '' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'careers-group',
        'info',
      ]),
    ],
    created (){
      this.$options.name = this.$route.meta.subtitle
      this.$options.metaInfo.title = this.$route.meta.subtitle
    },
    props: {
      id: {
        type: String,
        default: 'careergroup',
      },
    },
  }
</script>
